import { render, staticRenderFns } from "./PowerOfAttorney.vue?vue&type=template&id=1432c812&"
import script from "./PowerOfAttorney.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorney.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorney.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports